import { findMarketByLocale } from "../config/market-config";
import getLocaleFromPathname from "./getLocaleFromPathname";

export default function getMarketFromPathname(pathname: string) {
  const locale = getLocaleFromPathname(pathname);
  return findMarketByLocale(locale, true);
}
